import { render, staticRenderFns } from "./InfoBanner.vue?vue&type=template&id=d20b5268&scoped=true&"
import script from "./InfoBanner.vue?vue&type=script&lang=js&"
export * from "./InfoBanner.vue?vue&type=script&lang=js&"
import style0 from "./InfoBanner.vue?vue&type=style&index=0&id=d20b5268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20b5268",
  null
  
)

export default component.exports